// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	PrintButton: 'print-button',
	DownloadPdfButton: 'download-pdf-button',
	CopyToClipboardIcon: 'copy-to-clipboard-icon',
	CopyToClipboardIcon1: 'copy-to-clipboard-icon-1',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
